import { useCallback, useState } from 'react'

enum ApprovalStatus {
  UNREQUESTED = 'UNREQUESTED',
  APPROVED = 'APPROVED',
  UNAPPROVED = 'UNAPPROVED',
}

export interface TaskActualWorkApprovalStatusSearchCondition {
  excludingExpired?: boolean
  approvalStatus?: ApprovalStatus[]
}

export const getDefaultSearchCondition =
  (): TaskActualWorkApprovalStatusSearchCondition => ({
    excludingExpired: false,
    approvalStatus: [ApprovalStatus.UNREQUESTED, ApprovalStatus.UNAPPROVED],
  })

export const useSearchCondition = (
  initialCondition?: TaskActualWorkApprovalStatusSearchCondition
) => {
  const [searchCondition, setSearchCondition] =
    useState<TaskActualWorkApprovalStatusSearchCondition>(
      initialCondition || getDefaultSearchCondition()
    )

  const onChange = useCallback(
    (updated: Partial<TaskActualWorkApprovalStatusSearchCondition>) => {
      setSearchCondition(prev => ({ ...prev, ...updated }))
    },
    []
  )

  const resetCondition = useCallback(() => {
    setSearchCondition(getDefaultSearchCondition())
  }, [])

  return {
    searchCondition,
    onChange,
    resetCondition,
  }
}

export const useOnSingleValueChangedGenerator = (
  searchCondition: TaskActualWorkApprovalStatusSearchCondition,
  onChangeCondition: (
    updated: Partial<TaskActualWorkApprovalStatusSearchCondition>
  ) => void
) => {
  const onChangeValueGenerator = useCallback(
    (field: keyof TaskActualWorkApprovalStatusSearchCondition) =>
      (value: any) => {
        const updatedCondition = { [field]: value }
        onChangeCondition(updatedCondition)
      },
    [onChangeCondition]
  )

  return { onChangeValueGenerator }
}
